import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {FilterRecordsButton} from "../buttons/FilterRecordsButton.tsx";

const useTools = () => {
    // Read-only module (FNP-534): no Add/Delete. Reload + Filter only.
    const tools = [];

    tools.push(<FilterRecordsButton key='filter'/>);
    tools.push(<ReloadRecordsButton key='reload'/>);

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Metering Records')}
            tools={useTools()}
        />
    );
};
